import { Vikili } from "@/components/Vikili/Vikili";

const Index = () => <Vikili />;

export default Index;